import { render, staticRenderFns } from "./PostImage.vue?vue&type=template&id=6d9289c8&scoped=true&lang=pug&"
import script from "./PostImage.vue?vue&type=script&lang=js&"
export * from "./PostImage.vue?vue&type=script&lang=js&"
import style0 from "./PostImage.vue?vue&type=style&index=0&id=6d9289c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9289c8",
  null
  
)

export default component.exports